import axios from 'axios';

const baseURL = '/api';
const organizationDataURL = '/organizations';
const fieldAttributesURL = '/field_attributes';
const updateTypeURL = '/update_type';
const approveURL = '/approve';
const unapproveURL = '/unapprove';
const attachURL = '/attach';
const assetsURL = '/assets';

/**
 * Gets organizationData about a SINGLE organization
 * Hits endpoint: GET /api/organizations/:orgID
 * @param orgID the organization that should be found
 */
export const getOrganization = (orgID) => {
	return axios
		.get(`${baseURL}${organizationDataURL}/${orgID}`)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};

/**
 * Updates an organization with the given data
 * Hits endpoint: PUT /api/organizations/:orgID
 * @param orgID the organization that should be updated
 * @param orgData the new data
 */
export const putOrganization = (orgID, orgData) => {
	if (orgData.organization_type === 'Property') {
		orgData['property_info_attributes'] = {
			charity: orgData.charity,
			charity_number: orgData.charity_number,
		};
	}

	return axios
		.put(`${baseURL}${organizationDataURL}/${orgID}`, orgData)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};

/**
 * Updates organization type
 * Hits endpoint: PUT /api/organizations/:orgID/update_type
 * @param orgID the id of the org to update
 * @param organizationType the organization type to update to
 */
export const putOrganizationType = (orgID, organizationType) => {
	let data = { organization_type: organizationType };

	return axios
		.put(`${baseURL}${organizationDataURL}/${orgID}/${updateTypeURL}`, data)
		.then((response) => {
			return response;
		});
};

export const postOrganizationAsset = async (orgData, asset) => {
	try {
		const payload = {
			asset_id: asset?.asset_id,
			bytes: asset?.bytes,
			etag: asset?.etag,
			format: asset?.format,
			height: asset?.height,
			original_filename: asset?.original_filename,
			pages: asset.pages,
			path: asset.path,
			public_id: asset.public_id,
			resource_type: asset?.resource_type,
			secure_url: asset?.secure_url,
			thumbnail_url: asset?.thumbnail_url,
			url: asset?.url,
			version: asset?.version,
			version_id: asset?.version_id,
			width: asset?.width,
		};

		return await axios.post(
			`${baseURL}${organizationDataURL}/${orgData.id}/assets`,
			payload
		);
	} catch (error) {
		console.log(error);
	}
};

export const putOrganizationLogo = async (orgData, asset) => {
	try {
		const payload = {
			logo: {
				asset_id: asset?.id,
				bytes: asset?.bytes,
				etag: asset?.etag,
				format: asset?.format,
				height: asset?.height,
				original_filename: asset?.original_filename,
				pages: asset.pages,
				path: asset.path,
				public_id: asset.public_id,
				resource_type: asset?.resource_type,
				secure_url: asset?.secure_url,
				thumbnail_url: asset?.thumbnail_url,
				url: asset?.url,
				version: asset?.version,
				version_id: asset?.version_id,
				width: asset?.width,
			},
		};

		return await axios.put(
			`${baseURL}${organizationDataURL}/${orgData.id}`,
			payload
		);
	} catch (error) {
		console.log(error);
	}
};

export const deleteOrganizationAsset = async (orgID, asset) => {
	try {
		const payload = {
			id: asset?.id,
		};

		console.log('DELETE PAYLOAD', payload);
		return await axios.delete(
			`${baseURL}${organizationDataURL}/${orgID}/assets`,
			{ data: payload }
		);
	} catch (error) {
		console.log('ERROR:', error);
	}
};

/**
 * Get the field attributes
 * Hits endpoint: GET /api/organizations/field_attributes
 */
export const getFieldAttributes = () => {
	return axios
		.get(`${baseURL}${organizationDataURL}${fieldAttributesURL}`)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
			return undefined;
		});
};

/**
 * Approves org
 * Hits endpoint: POST /api/organizations/:orgID/approve
 * @param orgID the id of the org to approve
 */
export const approveOrg = (orgID) => {
	return axios
		.post(`${baseURL}${organizationDataURL}/${orgID}${approveURL}`)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};

/**
 * Unapproves org
 * Hits endpoint: POST /api/organizations/:orgID/unapprove
 * @param orgID the id of the org to unapprove
 */
export const unapproveOrg = (orgID) => {
	return axios
		.post(`${baseURL}${organizationDataURL}/${orgID}${unapproveURL}`)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};

/**
 * Attaches current user to the specified org
 * Hits endpoint: POST /api/organizations/:orgID/attach
 * @param userID the id of the user
 * @param orgID the id of the org
 */
export const attachUser = (userID, orgID) => {
	return axios
		.post(`${baseURL}${organizationDataURL}/${orgID}${attachURL}`, {
			userID: userID,
		})
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};

/**
 * Uploads a file for the specified org
 * Hits endpoint: POST /api/organizations/:orgID/assets
 * @param orgID the id of the org
 * @param asset the file
 */
export const postFile = (orgID, asset) => {
	return axios
		.post(`${baseURL}${organizationDataURL}/${orgID}${assetsURL}`, {
			asset: asset,
		})
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};

/**
 * Deletes a file for the specified org
 * Hits endpoint: DELETE /api/organizations/:orgID/assets
 * @param orgID the id of the org
 * @param asset the file
 */
export const deleteFile = (orgID, asset) => {
	return axios
		.delete(`${baseURL}${organizationDataURL}/${orgID}${assetsURL}`, {
			data: { asset: asset },
		})
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};

export const postOrganizationLogo = async (orgID, asset) => {
	console.log('MAKING API CALL WITH orgID-->', orgID);
	console.log('MAKING API CALL WITH asset-->', asset);
};
